var React = require('react');

function AnalyticalProducts (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M39.2857 9.57129L24 24.9999L18 18.9999L5.5 34.9999","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M29.8569 9.57129H39.2855V18.9999","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M39 36L4.85714 36L4.85713 9","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

AnalyticalProducts.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = AnalyticalProducts;

AnalyticalProducts.default = AnalyticalProducts;
